/**
 * Attaches the vendored panel's persistent element (useVendoredPanel) inside the popover body.
 * FloatingPanel unmounts its children in the bubble; this re-attaches the same element on restore and
 * puts back the scroll positions saved on detach, so minimise then restore keeps the tab and scroll.
 */
import React, { useLayoutEffect, useRef } from "react";

const INNER_SCROLLERS = ".v4-panel, .dm-scroll, .v4-scroll";
// Keyed by the persistent panel element: this component itself unmounts in the bubble.
const savedScroll = new WeakMap();

function saveScroll(body, hostEl) {
  const inner = [];
  hostEl.querySelectorAll(INNER_SCROLLERS).forEach((el) => {
    if (el.scrollTop || el.scrollLeft) inner.push({ el, top: el.scrollTop, left: el.scrollLeft });
  });
  return { top: body.scrollTop, inner };
}

function restoreScroll(body, saved) {
  if (!saved) return;
  body.scrollTop = saved.top;
  saved.inner.forEach(({ el, top, left }) => {
    if (el.isConnected) { el.scrollTop = top; el.scrollLeft = left; }
  });
}

export default function BrainPanelHost({ hostEl }) {
  const bodyRef = useRef(null);

  useLayoutEffect(() => {
    const body = bodyRef.current;
    if (!body || !hostEl) return undefined;
    body.appendChild(hostEl);
    restoreScroll(body, savedScroll.get(hostEl));
    return () => {
      savedScroll.set(hostEl, saveScroll(body, hostEl));
      if (hostEl.parentNode === body) body.removeChild(hostEl);
    };
  }, [hostEl]);

  return <div ref={bodyRef} className="d5-brain d5-brain-body" data-testid="brain-panel-body" />;
}
